import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Nav from 'react-bootstrap/Nav'
import Button from 'react-bootstrap/Button'
import API from 'state/API'
import { getLoading } from 'state/Request'

export default function Reloader({ reloader, resource, nav = false, ...btnProps }) {
	const { t }   = useTranslation()
	const loading = useSelector(getLoading(resource))

	const props   = {
		className: 'reloader',
		onClick  : reloader,
		disabled : loading,
		title    : loading? t('Loading...') : t('Reload'),
		children : <FontAwesomeIcon icon="sync" spin={loading} fixedWidth/>,
		...btnProps,
	}
	return nav? <Nav.Link as={Button} {...props}/> : <Button {...props}/>
}

Reloader.propTypes = {
	reloader: PropTypes.func.isRequired,
	resource: API.PROPTYPE_RESOURCES.isRequired,
	nav     : PropTypes.bool,
}
